import { PDF_H } from "../../constants/formflow/fieldTypes";

export function PDFPage({ pdfName }) {
  const lines1 = [1, 0.92, 1, 0.85, 1, 0.7, 1, 0.9, 1, 0.78];
  const lines2 = [1, 0.95, 0.88, 1, 0.65, 1, 0.82];
  return (
    <div style={{ padding: "64px 72px", pointerEvents: "none", userSelect: "none", minHeight: PDF_H }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 36 }}>
        <div style={{ width: 64, height: 64, background: "#f3f4f6", borderRadius: 8 }} />
        <div>
          <div style={{ height: 12, width: 140, background: "#e5e7eb", borderRadius: 3, marginBottom: 8 }} />
          <div style={{ height: 9, width: 180, background: "#f3f4f6", borderRadius: 3, marginBottom: 6 }} />
          <div style={{ height: 9, width: 110, background: "#f3f4f6", borderRadius: 3 }} />
        </div>
      </div>
      <div style={{ height: 2, background: "#e5e7eb", marginBottom: 28 }} />
      <div style={{ height: 20, width: "65%", background: "#e5e7eb", borderRadius: 4, marginBottom: 8 }} />
      <div style={{ height: 10, width: "38%", background: "#f3f4f6", borderRadius: 3, marginBottom: 28 }} />
      {lines1.map((w, i) => (
        <div key={i} style={{ height: 9, width: `${w * 100}%`, background: "#f3f4f6", borderRadius: 2, marginBottom: 10 }} />
      ))}
      <div style={{ height: 24 }} />
      <div style={{ height: 14, width: 140, background: "#e5e7eb", borderRadius: 3, marginBottom: 16 }} />
      {lines2.map((w, i) => (
        <div key={i} style={{ height: 9, width: `${w * 100}%`, background: "#f3f4f6", borderRadius: 2, marginBottom: 10 }} />
      ))}
      <div style={{ height: 28 }} />
      <div style={{ display: "flex", gap: 20 }}>
        {["Party A", "Party B"].map((l) => (
          <div key={l} style={{ flex: 1 }}>
            <div style={{ height: 11, width: "60%", background: "#e5e7eb", borderRadius: 3, marginBottom: 12 }} />
            <div style={{ height: 52, border: "1px dashed #d1d5db", borderRadius: 4 }} />
            <div style={{ height: 9, width: "80%", background: "#f3f4f6", borderRadius: 2, marginTop: 8 }} />
          </div>
        ))}
      </div>
      {pdfName && (
        <div
          style={{
            position: "absolute",
            bottom: 16,
            left: "50%",
            transform: "translateX(-50%)",
            fontSize: 10,
            color: "#9ca3af",
            fontFamily: "monospace",
          }}
        >
          {pdfName}
        </div>
      )}
    </div>
  );
}
